// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PhoneInput_wrapper__6UWlo","reactPhoneInput":"PhoneInput_reactPhoneInput__oeqhL","requiredAsterisk":"PhoneInput_requiredAsterisk__kv1iz"};